function callbackOnFileUploadFinished(data) {
  var url = data.filesUploaded[0].url;
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

  fetch(`/${window.I18n.locale}/user/update_avatar`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken
    },
    body: JSON.stringify({ avatar: url })
  });
}

function setup_users() {
  const avatarEl = document.getElementById("avatar");
  if (avatarEl) {
    avatarEl.addEventListener("click", () => {
      var options = {
        transformations: {
          circle: true,
          force: true
        },
        onUploadDone: data => callbackOnFileUploadFinished(data)
      };
      if (window.filestack_client) {
        window.filestack_client.picker(options).open();
      }
    });
  }

  const pillsTab = document.getElementById('pills-tab');
  if (pillsTab) {
    pillsTab.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link) return;

      e.preventDefault();

      // 1. Swap active states on tabs
      pillsTab.querySelectorAll('a').forEach(el => {
        el.classList.remove('bg-accent', 'text-zinc-950', 'font-bold', 'active');
        el.classList.add('text-zinc-400', 'hover:text-white', 'hover:bg-zinc-800/40');
      });
      link.classList.remove('text-zinc-400', 'hover:text-white', 'hover:bg-zinc-800/40');
      link.classList.add('bg-accent', 'text-zinc-950', 'font-bold', 'active');

      // 2. Swap visible panes (using active and show for Bootstrap compatibility)
      const targetId = link.getAttribute('data-target');
      if (targetId) {
        document.querySelectorAll('.tab-pane').forEach(pane => {
          pane.classList.remove('active', 'show');
        });
        const activePane = document.querySelector(targetId);
        if (activePane) {
          activePane.classList.add('active', 'show');
        }

        // 3. Update URL hash
        const newHash = targetId.replace('#', '');
        if (window.location.hash !== '#' + newHash) {
          window.history.pushState(null, null, '#' + newHash);
        }

        // 4. Trigger Rails remote UJS click if data-remote is set
        const href = link.getAttribute('href');
        if (href && href !== '#' && link.getAttribute('data-remote') === 'true') {
          fetch(href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(res => res.text())
            .then(data => {
              // Execute Rails returned JS
              var F = new Function(data);
              F();
            })
            .catch(err => console.error('Error fetching tab remote content:', err));
        }
      }
    });
  }

  // Handle initial page load with Hash redirects (e.g. /user/edit#plans)
  var url = document.location.toString();
  if (url.match('#')) {
    var tabName = url.split('#')[1];
    tabName = tabName.split('?')[0];
    var el = document.getElementById(tabName + "-tab");

    if (el) {
      // Toggle tab classes
      if (pillsTab) {
        pillsTab.querySelectorAll('a').forEach(link => {
          link.classList.remove('bg-accent', 'text-zinc-950', 'font-bold', 'active');
          link.classList.add('text-zinc-400', 'hover:text-white', 'hover:bg-zinc-800/40');
        });
      }
      el.classList.remove('text-zinc-400', 'hover:text-white', 'hover:bg-zinc-800/40');
      el.classList.add('bg-accent', 'text-zinc-950', 'font-bold', 'active');

      // Toggle pane visibility (using active and show for Bootstrap compatibility)
      document.querySelectorAll('.tab-pane').forEach(pane => {
        pane.classList.remove('active', 'show');
      });
      const activePane = document.getElementById(tabName);
      if (activePane) {
        activePane.classList.add('active', 'show');
      }

      // If remote, fetch the initial data
      const href = el.getAttribute('href');
      if (href && href !== '#' && el.getAttribute('data-remote') === 'true') {
        fetch(href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(res => res.text())
          .then(data => {
            var F = new Function(data);
            F();
          })
          .catch(err => console.error('Error fetching initial tab content:', err));
      }
    }
  }
}

document.addEventListener("turbo:load", () => {
  if (document.querySelector("body.users-edit")) {
    console.log("users.js initialized");
    setup_users();
  }
});
